import { render, staticRenderFns } from "./RateDistributionChart.vue?vue&type=template&id=71fd666e&scoped=true&"
import script from "./RateDistributionChart.vue?vue&type=script&lang=js&"
export * from "./RateDistributionChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fd666e",
  null
  
)

export default component.exports